import React, { ReactNode, useEffect, useState } from 'react';
import scrollIntoView, {
  CustomBehaviorOptions,
  Options,
} from 'scroll-into-view-if-needed';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
// import { Button } from "../button";
// import { Overlay } from "../overlay";
// import { MediaObject } from "../mediaobject";
// import { BubbleProps, BubbleContent } from "../bubble";
// import { useConfig } from "../util";
// import { injectValue } from "../_util/inject-value";
// import { useDefault } from "../_util/use-default";
// import { useTranslation } from "../i18n";
import {
  Button,
  Overlay,
  MediaObject,
  BubbleProps,
  BubbleContent,
  useConfig,
  useDefault,
} from 'tea-component';
// import { useConfig } from 'tea-component/es/util';
import { injectValue } from 'tea-component/es/_util/inject-value';
import { useTranslation } from 'tea-component/es/i18n';
import FullLoading from '@/pages/home/components/FullLoading';


interface HighlightElementsType {
  /**
   * 需要高亮的元素
   */
  element: Element | (() => Element);
  /**
   * 是否有圆角
   */
  hasRadius?: boolean;

  padding?: any;
}

export interface GuideStep {
  /**
   * 需要高亮的元素
   */
  highlightElements?: Array<HighlightElementsType>;
  /**
   * 需要高亮的元素
   */
  element: Element | (() => Element);

  /**
   * 是否有圆角
   */
  hasRadius?: boolean;

  /**
   * 定位元素的padding
   */
  padding?: any;

  /**
   * 气泡位置
   */
  placement?: BubbleProps['placement'];

  /**
   * 标题
   */
  title?: React.ReactNode;

  /**
   * 描述
   */
  description?: React.ReactNode;

  /**
   * 配图 URL
   */
  image?: string;

  /**
   * 弹出位置偏离参考位置的位移
   *
   * 如： `10`、`"50%"`、`"10 + 10%"`、`[10, 10]`
   *
   * @since 2.6.3
   */
  placementOffset?: BubbleProps['placementOffset'];

  /**
   * 气泡箭头是否指向目标元素中心
   * @since 2.6.3
   */
  arrowPointAtCenter?: BubbleProps['arrowPointAtCenter'];

  /**
   * 步骤气泡自定义类名
   * @since 2.5.0
   */
  bubbleClassName?: string;

  /**
   * 步骤气泡自定义样式
   * @since 2.5.0
   */
  bubbleStyle?: React.CSSProperties;

  /**
   * 当前步骤的节点元素 是否自动滚动到可视范围内，优先级高于Guide组件props中的autoScrollIntoView配置
   * 无默认值，没配置则用Guide组件props中配置的autoScrollIntoView
   */
  autoScrollIntoView?: boolean;

  /**
   * 滚动元素至视野范围的配置
   *
   * **详见：https://www.npmjs.com/package/scroll-into-view-if-needed**
   *
   * @default { behavior: "smooth", block: "center", inline: "center" }
   * @since 2.6.18
   */
  scrollIntoViewOptions?: CustomBehaviorOptions<any> | Options | boolean;
}

export interface GuideProps {
  /**
   * 引导步骤
   */
  steps?: GuideStep[];

  /**
   * 开始引导内容
   */
  startContent?: GuideStep;

  /**
   * 包含 `children` 时，在 `children` 渲染完成后展示引导
   */
  children?: JSX.Element;

  /**
   * 当前步骤. 如果有引导内容（非第一步），current值设为 -1
   */
  current?: number;

  /**
   * 步骤变化回调
   *
   * @since 2.6.10 支持 `context`
   */
  onCurrentChange?: (
    current: number,
    context: { from: 'start' | 'back' | 'next' | 'finish' | 'cancel' | 'nodata'; },
  ) => void;

  /**
   * 受控展示
   * @default true
   */
  visible?: boolean;

  /**
   * 隐藏取消按钮
   * @default false
   */
  hideCancelButton?: boolean;

  /**
   * 隐藏计数
   * @default false
   * @since 2.6.4
   */
  hideCount?: boolean;

  /**
   * 隐藏上一步按钮
   * @default false
   */
  showBackButton?: boolean;

  /**
   * 取消按钮文字
   * @default "跳过"
   */
  cancelText?: string;

  /**
   * 上一步按钮文字
   * @default "上一步"
   */
  backText?: string;

  /**
   * 下一步按钮文字
   * @default "下一步"
   */
  nextText?: string;

  /**
   * 完成按钮文字
   * @default "完成"
   */
  finishText?: string;

  /**
   * 是否自动滚动元素至视野范围
   * 针对单个步骤增加autoScrollIntoView配置的时候 scrollIntoView方法是直接调用的，没有受这个配置的控制，所以这里默认值改为true
   * @default true
   */
  autoScrollIntoView?: boolean;

  /**
   * 下一步（及完成）按钮样式
   * @default "link"
   * @since 2.6.18
   */
  nextButtonTheme?: 'link' | 'primary';

  /**
   * 是否显示遮罩
   * @default true
   * @since 2.7.4
   */
  showMask?: boolean;

  /**
   * 是否显示圆点
   * @default false
   * @since 2.7.4
   */
  showDot?: boolean;

  /**
   * 引导开始按钮文字
   * @default "确定"
   * @since 2.7.4
   */
  startFinishText?: string;

  /**
   * 是否显示椭圆动画
   * @default false
   * @since 2.7.4
   */
  visibleEllipseAnimation?: boolean;

  /**
   * 是否显示三角箭头
   * @default true
   * @since 2.7.4
   */
  visibleTriangleArrow?: boolean;

  /**
   * 是否显示关闭按钮
   * @default false
   * @since 2.7.4
   */
  visibleCloseBtn?: boolean;

  /**
   * 是否显示Loading
   * @default true
   * @since 2.7.4
   */
  showLoading?: boolean;
  /**
   * 是否自定义body
   * @default 
   * @since 2.7.4
   */
  CustomBodyElement?:ReactNode;
  /**
   * 自定义检测最大次数
   * @default 60
   * @since 2.7.4
   */
  checkMaxCount?:number;
  /**
   * 自定义遮罩透明度
   * @default 0.4
   * @since 2.7.4
   */
  maskOpacity?:number;
}



const borderWidth = 0;
const borderRadius = 4; // 如蒙层挖空需要圆角则对应数值，反之赋值0

function getOffset(element: HTMLElement) {
  if (!element) {
    return {};
  }
  const { body } = document;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  try {
    const x = element.getBoundingClientRect();
    return {
      top: x.top + scrollTop,
      width: x.width,
      height: x.height,
      // left: x.left + scrollLeft,
      left: x.left
    };
  } catch (_) {
    return {};
  }
}

// 抽取body公共函数
const renderBody = (step, classPrefix) => {
  const { title, subtitle, description, image } = step;

  return (
    <div className={`${classPrefix}-guide__body`}>
      <MediaObject
        media={
          image && (
            <img className={`${classPrefix}-guide__image`} src={image} alt="" />
          )
        }
      >
        {title && (
          <div className={`${classPrefix}-guide__messagetitle`}>
            <span>{title}</span>
            {subtitle && <><span>&nbsp;-&nbsp;&nbsp;</span><span>{subtitle}</span></>}
          </div>
        )}
        {description && (
          <div className={`${classPrefix}-guide__messagetext`}>
            {description}
          </div>
        )}
      </MediaObject>
    </div>
  );
};

// 抽取圆点函数
const renderDot = (count, current, classPrefix) => (
  <div className={`${classPrefix}-guide__dot`}>
    {[...Array(count)].map((items, index) => (
      <span
        key={index}
        className={classNames(`${classPrefix}-guide__dot-item`, {
          'is-active': index === current,
        })}
      ></span>
    ))}
  </div>
);

// 获取overlay公共属性
const getOverlayCommonProps = (zIndex, key, placement, placementOffset, className = '') => ({
  key,
  placement,
  placementOffset,
  modifiers: {
    flip: { enabled: false },
    preventOverflow: { enabled: false },
    hide: { enabled: false },
  },
  overlayProps: { style: { zIndex }, className },
});

// 获取svg高亮位置
const getHightLightPath = (offset: any, hasRadius = true, padding: any = {}) => {
  const { height, width, top, left } = offset || {};
  const { paddingLeft = 0, paddingTop = 0, paddingRight = 0, paddingBottom = 0 } = padding || {};
  if (hasRadius) {
    return `M ${left - paddingLeft - borderWidth} ${top - paddingTop - borderWidth + borderRadius
    }  q ${0} ${-borderRadius} ${borderRadius} ${-borderRadius} H ${left + width + paddingRight + borderWidth - borderRadius
    }  q ${borderRadius} ${0} ${borderRadius} ${borderRadius} V ${top + height + paddingBottom + borderWidth - borderRadius
    }  q ${0} ${borderRadius} ${-borderRadius} ${borderRadius} H ${left - paddingLeft - borderWidth + borderRadius
    } q ${-borderRadius} ${0} ${-borderRadius} ${-borderRadius} L ${left - paddingLeft - borderWidth
    } ${top - paddingTop - borderWidth} Z`;
  }

  return `M ${left - paddingLeft - borderWidth} ${top - paddingTop - borderWidth} H ${left + width + paddingRight +
  borderWidth} V ${top + height + paddingBottom + borderWidth} H ${left - paddingLeft -
  borderWidth} L ${left - paddingLeft - borderWidth} ${top - paddingTop - borderWidth} Z`;
};

export function Guide({
  steps = [],
  startContent,
  children = null,
  visible = true,
  checkMaxCount = 60,
  autoScrollIntoView = true,
  current,
  onCurrentChange,
  showBackButton,
  hideCount,
  hideCancelButton,
  cancelText,
  backText,
  nextText,
  finishText,
  nextButtonTheme = 'link',
  showDot = false,
  showMask = true,
  startFinishText,
  visibleEllipseAnimation = false,
  visibleTriangleArrow = true,
  visibleCloseBtn = false,
  showLoading = true,
  CustomBodyElement,
  maskOpacity = 0.4
}: GuideProps) {
  const t = useTranslation();
  const { classPrefix } = useConfig();
  const [currentIndex, setCurrentIndex] = useDefault(
    current,
    -1,
    onCurrentChange,
  );

  const [isStartStep, setIsStartStep] = useState(false);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [resizeCount, setResizeCount] = useState<number>(0);

  useEffect(() => {
    const updateSize = () => {
      setResizeCount(val => val + 1);
    };
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  // 保证子级结点存在
  useEffect(() => {
    if (startContent && (typeof current === 'undefined' || current < 0)) {
      setIsStartStep(true);
    } else {
      setIsStartStep(false);
    }

    if (current <= -2) {
      setIsStartStep(false);
    }

    if (typeof current === 'undefined') {
      setCurrentIndex(0, { from: 'start' });
    }
  }, [current, startContent, setCurrentIndex]);

  let step = startContent;
  let count = 0;

  if (steps && !isStartStep) {
    step = steps[currentIndex];
    count = steps.length;
  }

  useEffect(() => {
    if (step) {
      const element = injectValue(step.element)();
      const isAutoScrollIntoView = step?.autoScrollIntoView ?? autoScrollIntoView ?? true;
      if (element) {
        isAutoScrollIntoView && scrollIntoView(
          element,
          step.scrollIntoViewOptions || {
            behavior: 'auto',
            block: 'center',
            inline: 'center',
            // scrollMode: 'if-needed'
          },
        );
      } else {
        setLoading(true);
        let checkCount = 0;
        const checkElement = () => {
          const element = injectValue(step.element)();
          if (!element && checkCount < checkMaxCount) {
            checkCount += 1;
            setTimeout(() => {
              checkElement();
            }, 100);
          } else {
            if (element) {
              isAutoScrollIntoView && scrollIntoView(
                element,
                step?.scrollIntoViewOptions || {
                  behavior: 'auto',
                  block: 'center',
                  inline: 'center',
                  // scrollMode: 'if-needed'
                },
              );
            } else {
              setCurrentIndex(-2, { from: 'nodata' });
            }
            setLoading(false);
          }
        };
        checkElement();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoScrollIntoView, step]);

  const getHighlightElementsPath = () => {
    let path = '';
    if (step) {
      const { highlightElements = [] } = step;
      highlightElements.forEach((item) => {
        const { element: ele, hasRadius, padding = {} } = item;
        if (ele) {
          const element = injectValue(ele)();
          path += ` ${  getHightLightPath(getOffset(element as HTMLElement), !!hasRadius, padding,)}`;
        }
      });
    }
    return path;
  };

  if (!visible || !step) {
    return null;
  }

  let offset = step.placementOffset || 10;
  if (step.arrowPointAtCenter) {
    offset = Array.isArray(offset) ? offset[1] : offset;
    const [, placementModifier] = step.placement.split('-');
    if (placementModifier === 'start') {
      offset = ['50%-26', offset];
    } else if (placementModifier === 'end') {
      offset = ['26-50%', offset];
    }
  }

  const element = injectValue(step.element)();
  const { placement } = step;
  const { height, width } = getOffset(element as HTMLElement);

  if (!element) {
    // todo loading 的时候渲染lading效果
    if (loading && showLoading) {
      return <FullLoading />;
    }
    return null;
  }

  const maskLayerProps = getOverlayCommonProps(
    9999,
    'highlight',
    'top-start',
    0,
  );
  const layerProps = getOverlayCommonProps(10001, 'bubble', placement, offset);
  // const extraImgLayerProps = getOverlayCommonProps(10000, 'extraImg', placement, offset);

  const { hasRadius = true, padding = {} } = step;

  return (
    <Overlay
      layers={[
        // eslint-disable-next-line react/jsx-key
        <Overlay.Layer
          visible={true}
          content={({ style }) => {
            const left = +style.left;
            const top = +style.top;
            // const p = `M ${left - borderWidth} ${
            //   top - borderWidth + borderRadius
            // }  q ${0} ${-borderRadius} ${borderRadius} ${-borderRadius} H ${
            //   left + width + borderWidth - borderRadius
            // }  q ${borderRadius} ${0} ${borderRadius} ${borderRadius} V ${
            //   top + height + borderWidth - borderRadius
            // }  q ${0} ${borderRadius} ${-borderRadius} ${borderRadius} H ${
            //   left - borderWidth + borderRadius
            // } q ${-borderRadius} ${0} ${-borderRadius} ${-borderRadius} L ${
            //   left - borderWidth
            // } ${top - borderWidth} Z`;

            const p = getHightLightPath({ left, top, width, height }, hasRadius, padding) + getHighlightElementsPath();

            return (
              <svg
                style={{
                  top: 0,
                  left: 0,
                  overflow: 'hidden',
                  position: 'fixed',
                  width: '100vw',
                  height: '100vh',
                  fillRule: 'evenodd',
                }}
              >
                {/* <defs>
  <clipPath id="clipPath">
  <rect x={left - borderWidth} y={top - borderWidth} width={width} height={height} rx="4" ry="4" />
  </clipPath>
</defs>
                 <rect x='0' y='0' width='100vw' height='100vh'  clip-path="url(#clipPath)"  fill="#000000" opacity={!showMask ? 0 : 0.4}  /> */}
                <path
                  d={`${p} M 0 0 H 9999 V 9999 H 0 L 0 0 Z`}
                  fill="#000000"
                  opacity={!showMask ? 0 : maskOpacity}
                />
                {/* <path*/}
                {/*  d={`M 0 300 H 200 V 350 H 0 L 0 300 Z M 0 600 H 200 V 650 H 0 L 0 600 Z M 0 0 H 9999 V 9999 H 0 L 0 0 Z`}*/}
                {/*  fill="#000000"*/}
                {/*  opacity={!showMask ? 0 : 0.6}*/}
                {/*/ >*/}
                {/* <path*/}
                {/*  d={`M 0 0 H 200 V 50 H 0 L 0 0 Z`}*/}
                {/*  fill="#000000"*/}
                {/*  opacity={0}*/}
                {/*/ >*/}
                {/* <path*/}
                {/*  d={`M ${left} ${top} H ${left + width} V ${top +*/}
                {/*  height} H ${left} L ${left} 0 Z ${p}`}*/}
                {/*  fill="#cccccc"*/}
                {/*  opacity={showMask ? 0 : 1}*/}
                {/*/ >*/}
              </svg>
            );
          }}
          {...maskLayerProps}
        />,
        // eslint-disable-next-line react/jsx-key
        <Overlay.Layer
          visible
          {...layerProps}
          content={({ placement }) => (
            <BubbleContent
              key={currentIndex}
              placement={placement}
              className={classNames(
                `${classPrefix}-guide`,
                step.bubbleClassName,
                'guide-animation-enter',
                {
                  [`${classPrefix}-guide--start`]: !showDot,
                  'is-show-triangle-arrow': visibleTriangleArrow,
                },
              )}
              style={step.bubbleStyle}
            >
              {visibleEllipseAnimation && (
                <div className={`${classPrefix}-guide__flashing-light`}>
                  <span
                    className={`${classPrefix}-guide__flashing-light-dot`}
                  ></span>
                </div>
              )}
              {visibleCloseBtn && (
                <Button
                  type="icon"
                  icon="close"
                  htmlType="button"
                  className={`${classPrefix}-guide__close-icon`}
                  onClick={() => {
                    setCurrentIndex(-2, { from: 'cancel' });
                  }}
                  aria-label={t.closeText}
                />
              )}
              {CustomBodyElement ? (
                CustomBodyElement
              ) : (
                <>
                  {renderBody(step, classPrefix)}
                  <div className={`${classPrefix}-guide__footer`}>
                    {showDot &&
                      count &&
                      count > 0 &&
                      renderDot(count, current, classPrefix)}
                    {!hideCount && count > 0 ? (
                      <span className={`${classPrefix}-guide__step-count`}>{`${current + 1
                      }/${count}`}</span>
                    ) : (
                      <span></span>
                    )}
                    <div className={`${classPrefix}-guide__btn-group`}>
                      {!hideCancelButton &&
                        (current < count - 1 || isStartStep) && (
                        <Button
                          type="text"
                          htmlType="button"
                          onClick={() => {
                            setCurrentIndex(-2, { from: 'cancel' });
                          }}
                        >
                          {cancelText || t.guideCancel}
                        </Button>
                      )}
                      {showBackButton &&
                        ((startContent && current >= 0) ||
                          (!startContent && current > 0)) && (
                        <Button
                          type="text"
                          htmlType="button"
                          className={`${classPrefix}-guide__btn-back`}
                          onClick={() => {
                            setCurrentIndex(current - 1, { from: 'back' });
                          }}
                        >
                          {backText || t.guideBack}
                        </Button>
                      )}
                      {current < count - 1 ? (
                        <Button
                          type={nextButtonTheme}
                          htmlType="button"
                          onClick={() => {
                            setCurrentIndex(current + 1, { from: 'next' });
                          }}
                        >
                          {nextText || t.guideNext}
                          {/* {!hideCount && count > 0
                        ? ` ${current + 1}/${count}`
                        : ""} */}
                        </Button>
                      ) : (
                        <Button
                          type={nextButtonTheme}
                          htmlType="button"
                          className={`${classPrefix}-guide__btn-finish`}
                          onClick={() => {
                            if (isStartStep) {
                              setCurrentIndex(0, { from: 'start' });
                            } else {
                              setCurrentIndex(-2, { from: 'finish' });
                            }
                          }}
                        >
                          {isStartStep
                            ? startFinishText || t.okText
                            : finishText || t.guideFinish}
                          {/* {!hideCount && count > 0
                        ? ` ${current + 1}/${count}`
                        : ''} */}
                        </Button>
                      )}
                    </div>
                  </div>
                </>
              )}
            </BubbleContent>
          )}
        />,
        step.extImage && (
          <Overlay.Layer
            visible
            {...getOverlayCommonProps(10000, 'extraImg', placement, offset, step.extImage?.wrapperClassName)}
            placement={step.extImage?.placement || placement}
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            content={({ placement }) => (
              <img
                key={currentIndex}
                style={step.extImage?.style}
                className={`${classPrefix}-guide-extraimg guide-animation-enter ${step.extImage?.className?step.extImage?.className:''}`}
                src={step.extImage.image}
                alt=""
              />
            )}
          />
        ),

        // eslint-disable-next-line array-callback-return
        step?.highlightElements?.map((task) => {
          if (!isEmpty(task?.extImage)) {
            const {
              image = '',
              style = {},
              className = '',
            } = task?.extImage || {};
            return (
              // eslint-disable-next-line react/jsx-key
              <Overlay.Layer
                overlayProps={{ style: { zIndex: 100001 } }}
                visible
                referenceElement={task.element}
                content={() => (
                  <img
                    key={currentIndex}
                    style={style}
                    className={`${classPrefix}-guide-extraimg guide-animation-enter ${
                      className || ''
                    }`}
                    src={image}
                    alt=""
                  />
                )}
              />
            );
          }
        }),
      ]}
    >
      {(ref) => (
        <div
          ref={() => {
            if (typeof ref === 'function') {
              ref(element as HTMLElement);
            }
          }}
        >
          {children}
        </div>
      )}
    </Overlay>
  );
}

Guide.displayName = 'Guide';
